import { useEffect } from "react";

/**
 * @name useEmbedInit
 * @description as we use dangerouslySetInnerHTML to render page, for those
 * embed elments like fb/ins/twitter/tiktok which need script to dynamicly reload(render) the element, will not excute the script in terms of dangerouslySetInnerHTML.
 * For fb and ins, it has been dealt with, but for twitter and tiktok, need to re-init, if init funcion not provided, can reload excutive script again.
 *
 */
export function useEmbedInit() {
  // reload twitter excute script
  useEffect(() => {
    const existEmbedCode = document.querySelectorAll(
      "blockquote.twitter-tweet",
    );
    if (!existEmbedCode.length) {
      return;
    } else {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.id = "twitter-embed-script";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  // reload reddit excute script
  useEffect(() => {
    const existEmbedCode = document.querySelectorAll(
      "blockquote.reddit-embed-bq",
    );
    if (!existEmbedCode.length) {
      return;
    } else {
      const script = document.createElement("script");
      script.src = "https://embed.reddit.com/widgets.js";
      script.id = "reddit-emebed-script";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return;
}
